import { Component, OnInit, Input, EventEmitter, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { IstSummaryService } from 'src/app/services/ist/ist-summary.service';
import { currencyOptionsConstant, titleOptionsConstant, serviceConstants} from 'src/app/constants/service.constants';
import { Subject } from 'rxjs';
import { GridApi } from 'ag-grid-community';
import * as find from 'lodash/find';
import * as cloneDeep from 'lodash/cloneDeep';
import { DeleteOperationsRenderer } from 'src/app/common/client-grid/delete-operations.component';
import * as findIndex from 'lodash/findIndex';
import { EditAndDeleteOperationsRenderer } from 'src/app/common/client-grid/edit-and-delete-operations.component';
import { IstDataShareService } from '../../../../services/ist/ist-datashare.service';
import { CommonService } from '../../../../services/common.service';
import { MessageBoxComponent } from '../../../../common/message-box/message-box.component';
import { UserService } from '../../../../services/user.service';
import { ExtendedFormControlsComponent } from 'src/app/common/extended-form-controls/extended-form-controls.component';
import { Document_Upload_File } from '../../../../models/common';
import * as $ from 'jquery';
import { DeleteBoxComponent } from '../../../../common/delete-box/delete-box.component';
import { EapStudyTeamOrganizationViewModalComponent } from '../../eap-study-team-organization/eap-study-team-organization-view-modal/eap-study-team-organization-view-modal.component';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-eap-study-team-team-view-modal',
  templateUrl: './eap-study-team-team-view-modal.component.html',
  styleUrls: ['./eap-study-team-team-view-modal.component.scss']
})
export class EapStudyTeamTeamViewModalComponent implements OnInit {

  formFields;
  titleOptions = [
    { value: '1', label: 'Mr.' },
    { value: '2', label: 'Mrs.' },
    { value: '3', label: 'Dr.' },
    { value: '4', label: 'Rev.' },
    { value: '5', label: 'Ms.' },
  ];
  columnDefs;
  gridApi: GridApi;
  rowData;
  gridOptions;
  studyTeamTeamForm:UntypedFormGroup
  loadTeam = false;
  content: any;
  heading: string;
  action: Subject<any> = new Subject();
  formData: FormData;
  files: any[];
  uploadInput: EventEmitter<any>;
  humanizeBytes: Function;
  dragOver: boolean;
  currencyOptions = currencyOptionsConstant;
  frameworkComponents;
  context;
  ApplicationID: any;
  FilesList: any = [];

  OrganizationsList = [];
  RolesList = [];
  userType: string = "";
  documaent_attach_list: Document_Upload_File[] = [];
  IsMultipermission: string = "yes";
  IsClicked = false;
  @ViewChild('extended') extendedForm: ExtendedFormControlsComponent;

  constructor(
    private summaryService: IstSummaryService,
    public modalRef: NgbActiveModal,
    private modalService: NgbModal,
    private istDatashareserivse: IstDataShareService,
    public commonService: CommonService,
    private userService: UserService,
  ) {
    
  }

  ngOnInit() {

    this.columnDefs = [
      {
        "headerName": "Organization",
        "field": "MemberOrganizationName",
        "sort": "asc",
      },
      {
        "headerName": "Role",
        "field": "RoleName",
      },{
        headerName: "",
        field: "value",
        cellRenderer: "deleteRenderer",
        IsRequiredDelete: this.heading == 'View' ? false : true,
        colId: "params",
        width: 50,
        sortable: false,
        cellStyle: { "overflow": 'visible' }
      }
    ]

    this.rowData = [];

    this.gridOptions = {
      pagination: true,
      rowSelection: 'single',
      rowHeight: 32,

      defaultColDef: {
        sortable: true,
        suppressNavigable: true,
        cellClass: 'no-border',
        suppressMovable: true,

      }
    }

    this.context = { componentParent: this };
    this.frameworkComponents = {
      deleteRenderer: EditAndDeleteOperationsRenderer
    };  


    this.files = [];
    this.userType = this.userService.getUserType();
    this.istDatashareserivse.ApplicationID.subscribe(x => { this.ApplicationID = x; })
    this.studyTeamTeamForm = new UntypedFormGroup({
      ID: new UntypedFormControl(""),
      APPLICATION_ID: new UntypedFormControl(""),
      TITLE: new UntypedFormControl(""),
      FIRST_NAME: new UntypedFormControl(""),
      MIDDLE_NAME: new UntypedFormControl(""),
      LAST_NAME: new UntypedFormControl(""),
      OCCUPATION: new UntypedFormControl(""),
      SPECIALIZATION: new UntypedFormControl(""),
      LICENSE_NO: new UntypedFormControl(""),
      CITY: new UntypedFormControl(""),
      PROVINCE: new UntypedFormControl(""),
      COUNTRY: new UntypedFormControl(""),
      ADDRESS: new UntypedFormControl(""),
      POSTAL_CODE: new UntypedFormControl(""),
      EMAIL: new UntypedFormControl("", [Validators.email]),
      CONTACT_METHOD: new UntypedFormControl(""),
      PHONE: new UntypedFormControl("", [Validators.pattern("^[0-9]*$"),
                Validators.maxLength(15)]),
      PHONE_EXT: new UntypedFormControl("", [Validators.pattern("^[0-9]*$"), Validators.maxLength(5)]),
      OTHER_PHONE: new UntypedFormControl("", [Validators.pattern("^[0-9]*$"),
        Validators.maxLength(15)]),
      OTHER_PHONE_EXT: new UntypedFormControl("", [Validators.pattern("^[0-9]*$"), Validators.maxLength(5)]),
      FAX: new UntypedFormControl(""),
      FAX_EXT: new UntypedFormControl("", [Validators.pattern("^[0-9]*$"), Validators.maxLength(5)]),
      NOTES: new UntypedFormControl(""),
      RoleID: new UntypedFormControl(""),
      OrgID: new UntypedFormControl(""),
    });

    //setTimeout(() => {
    //  this.loadTeam = true;
    //}, 350);

    if (this.heading == "Edit" || this.heading == "View") {
      this.getStudyTeamData();
     // this.GetGridData();
    }

    if (this.heading === 'Add') { //Add mode 
      this.content.id = this.commonService.getUniqueId();
    }
    //this.istDatashareserivse.IstMemberOrgList.subscribe(x => {
    //  debugger;
    //  this.rowData = x;
    //  setTimeout(() => {
    //    this.loadTeam = true;
    //  }, 350);
    //});
    this.setMasterData();
  }
  setMasterData() {
    this.summaryService.masterData("api/EAPStudyTeam/GetMasterData?ApplicationID=" + this.ApplicationID + "&RecordID=" + this.content.id).subscribe(summary => {
      debugger;
      this.OrganizationsList = summary["MasterData1"];
      this.RolesList = summary["MasterData2"];
      if (summary["MasterData3"] != null && summary["MasterData3"] != undefined) {
        this.IsMultipermission = summary["MasterData3"][0].value;
      }
    });
  }
  PostalCodekeyUP(value: string) {
    if (value.length == parseInt("5")) {
      this.commonService.getCity(value).subscribe(x => {
        if (x.Status) {
          this.studyTeamTeamForm.controls["CITY"].setValue(x.Data.City);
          this.studyTeamTeamForm.controls["PROVINCE"].setValue(x.Data.StateFullName);
          this.studyTeamTeamForm.controls["COUNTRY"].setValue(x.Data.Country);
        }
      });
    }
    else
    {
      this.studyTeamTeamForm.controls["CITY"].setValue("");
      this.studyTeamTeamForm.controls["PROVINCE"].setValue("");
      this.studyTeamTeamForm.controls["COUNTRY"].setValue("");
    }
  }
  GetGridData() {
    this.summaryService.getScreenDataForEdit("api/EAPStudyTeam/GridDataEdit?RecordID1=" + this.content.id + "&ApplicationID1=" + this.ApplicationID).subscribe(result => {
      debugger;
     this.rowData = result as [];
     // this.istDatashareserivse.setIstMemberOrgList(this.rowData);
    });
  }
   getStudyTeamData(){
     
     this.summaryService.getScreenDataForEdit("api/EAPStudyTeam/Edit?RecordID=" + this.content.id+ "&ApplicationID=" + this.ApplicationID).subscribe(result => {
       debugger;
       this.FilesList = result["FilesList"];
       this.studyTeamTeamForm.patchValue({
         ID: result["Modal"]["ID"],
         APPLICATION_ID: result["Modal"]["APPLICATION_ID"],
         TITLE: result["Modal"]["TITLE"],
         FIRST_NAME: result["Modal"]["FIRST_NAME"],
         MIDDLE_NAME: result["Modal"]["MIDDLE_NAME"],
         LAST_NAME: result["Modal"]["LAST_NAME"],
         OCCUPATION: result["Modal"]["OCCUPATION"],
         SPECIALIZATION: result["Modal"]["SPECIALIZATION"],
         LICENSE_NO: result["Modal"]["LICENSE_NO"],
         ADDRESS: result["Modal"]["ADDRESS"],
         POSTAL_CODE: result["Modal"]["POSTAL_CODE"],
         EMAIL: result["Modal"]["EMAIL"],
         CONTACT_METHOD: result["Modal"]["CONTACT_METHOD"],
         PHONE: result["Modal"]["PHONE"],
         PHONE_EXT: result["Modal"]["PHONE_EXT"],
         OTHER_PHONE: result["Modal"]["OTHER_PHONE"],
         OTHER_PHONE_EXT: result["Modal"]["OTHER_PHONE_EXT"],
         FAX: result["Modal"]["FAX"],
         FAX_EXT: result["Modal"]["FAX_EXT"],
         NOTES: result["Modal"]["NOTES"],
         CITY: result["Modal"]["CITY"],
         PROVINCE: result["Modal"]["PROVINCE"],
         COUNTRY: result["Modal"]["COUNTRY"],
         RoleID: result["Modal"]["RoleID"] == null ? "" : result["Modal"]["RoleID"],
         OrgID: result["Modal"]["OrgID"],
       });

       if (this.heading == "View") {
         this.studyTeamTeamForm.disable();

       }
     });
   }
 
  DownloadFile(ID) {
    var fileID = ID;
    let Url = serviceConstants.apiURL + "api/ISTFileAttachments/Downloadfile?FileID=" + fileID;
    window.open(Url);
  }
  onRowDoubleClicked(event) {
  
  }
  ClosePopup() {
    debugger;
    
    this.modalRef.close();
  }
  SaveStudyTeam() {
    if (this.IsClicked == false) {
     
      if (this.validateControls() && this.extendedForm.validateControls()) {
        this.IsClicked = true;
        var formData = this.studyTeamTeamForm.value;
        formData.APPLICATION_ID = this.ApplicationID;
        if (formData["PHONE_EXT"] != null && formData["PHONE_EXT"] != undefined) {
          formData["PHONE_EXT"] = parseInt(formData["PHONE_EXT"]);
        }
        if (formData["OTHER_PHONE_EXT"] != null && formData["OTHER_PHONE_EXT"] != undefined) {
          formData["OTHER_PHONE_EXT"] = parseInt(formData["OTHER_PHONE_EXT"]);
        }
        if (formData["FAX_EXT"] != null && formData["FAX_EXT"] != undefined) {
          formData["FAX_EXT"] = parseInt(formData["FAX_EXT"]);
        }
        formData.RECORD_STATE = parseInt("0");
        formData.CREATED_DATE = new Date();
        formData.LAST_UPDATED_DATE = new Date();
        formData.MemberOrganizationsList = [];
        //let data = new {}
        //formData.MemberOrganizationsList.push();
        //this.istDatashareserivse.IstMemberOrgList.subscribe(x => {
        //  formData.MemberOrganizationsList = x;
        //});
        let formData1 = new FormData();
        if (this.documaent_attach_list != null && this.documaent_attach_list.length > 0) {
          for (let i = 0; i < this.documaent_attach_list.length; i++) {
            this.documaent_attach_list[i].TRANSACTION_ID = ("" + (i + 1));
            formData1.append(("" + (i + 1)), this.documaent_attach_list[i].File);
          }
        }

        if (this.heading == "Add") {
          formData["ID"] = this.content.id;
          formData1.append("ScreenData", JSON.stringify(formData));
          this.summaryService.FilesInsert("api/EAPStudyTeam/Insert", formData1).subscribe(result => {
            this.extendedForm.saveControls(result.TransactionCode).subscribe(result1 => {
              this.commonService.SuccessBanner('Data has been inserted successfully.');
             // this.modalService.open(MessageBoxComponent, { data: { heading: 'Insert', content: { heading: '', description: 'Data has been inserted successfully.' } } });
               
               this.modalRef.close();
              //this.heading = "Edit";
               this.IsClicked = false;
              //this.studyTeamTeamForm.controls["ID"].setValue(this.content.id);
            });

          });
        }
        else {
          formData1.append("ScreenData", JSON.stringify(formData));
          this.summaryService.FilesInsert("api/EAPStudyTeam/Update", formData1).subscribe(result => {
            this.extendedForm.saveControls(result.TransactionCode).subscribe(result1 => {
              this.commonService.SuccessBanner('Data has been updated successfully.');
            //  this.modalService.show(MessageBoxComponent, { data: { heading: 'Update', content: { heading: '', description: 'Data has been updated successfully.' } } });
              
              this.modalRef.close();
              this.IsClicked = false;

            });
          });
        }

      }
    }
   
  }
  uploadchange(event): void {
    if (this.documaent_attach_list == undefined || this.documaent_attach_list == null) {
      this.documaent_attach_list = [];
    }
    for (let i = 0; i < event.target.files.length; i++) {
      let uploadFile = new Document_Upload_File();
      uploadFile.ID = ("" + (i + 1));
      uploadFile.DOCUMENT_NAME = event.target.files[i].name;
      uploadFile.File = event.target.files[i];
      uploadFile.Status = "Add";
      this.documaent_attach_list.push(uploadFile);
    }
  }
  DeleteUpload(file, documentattach): void {
    if (file.Status == "Add") {
      let code = file.ID;
      this.documaent_attach_list= this.documaent_attach_list.filter(function (sec) {
        return sec.ID != code;
      }, code);
    }
    else {
      file.Status = "Delete";
    }
  }
  DeleteSavedUpload(item): void {
    this.summaryService.DeleteRecord("api/ISTFileAttachments/DeleteFile?FileID=" + item).subscribe(result => {
      let code = item;
      this.FilesList = this.FilesList.filter(function (sec) {
        return sec.ID != code;
      });
    });
  }

  SaveUploadAttachment(id): void {
    debugger;

    let Url = serviceConstants.apiURL + "api/EAPStudyTeam/UploadFiles?TransactionID=" + id;
    const event: any = {
      type: 'uploadAll',
      url: Url,
      method: 'POST',
      data: {Id:""},
    };

    this.uploadInput.emit(event);
    this.files = [];
  }
  //addNewOrg() {
  //  debugger;
  //  let modalRef= this.modalService.show(EapStudyTeamOrganizationViewModalComponent, {
  //    backdrop: false,
  //    keyboard: false,
  //    ignoreBackdropClick: true,
  //    class: 'modal-vlg modal-full-height modal-right',
  //    animated: true,
  //    data: {
  //      heading: 'Add',
  //      content: { id: "", ApplicationID: ""},

  //    }
  //  });
   
  //}
  validateControls(): boolean {
    let isValid = true;
    let message = "";
    const formData = this.studyTeamTeamForm.value;
    if (formData.TITLE === null || formData.TITLE === "") {
      $("#TITLE").addClass("ng-touched ng-invalid validate-error");
      $("#TITLE").removeClass("ng-untouched ng-valid");
      message += "Please enter Title.<br/>";
      isValid = false;
    } else {
      $("#TITLE").addClass("ng-untouched ng-valid");
      $("#TITLE").removeClass("ng-touched ng-invalid validate-error");
    }

    if (formData.FIRST_NAME === null || formData.FIRST_NAME === "") {
      $("#FIRST_NAME").addClass("ng-touched ng-invalid validate-error");
      $("#FIRST_NAME").removeClass("ng-untouched ng-valid");
      message += "Please enter First Name.<br/>";
      isValid = false;
    } else {
      $("#FIRST_NAME").addClass("ng-untouched ng-valid");
      $("#FIRST_NAME").removeClass("ng-touched ng-invalid validate-error");
    }

    if (formData.LAST_NAME === null || formData.LAST_NAME === "") {
      $("#LAST_NAME").addClass("ng-touched ng-invalid validate-error");
      $("#LAST_NAME").removeClass("ng-untouched ng-valid");
      message += "Please enter Last Name.<br/>";
      isValid = false;
    } else {
      $("#LAST_NAME").addClass("ng-untouched ng-valid");
      $("#LAST_NAME").removeClass("ng-touched ng-invalid validate-error");
    }


    if (formData.OCCUPATION === null || formData.OCCUPATION === "") {
      $("#OCCUPATION").addClass("ng-touched ng-invalid validate-error");
      $("#OCCUPATION").removeClass("ng-untouched ng-valid");
      message += "Please enter Occupation.<br/>";
      isValid = false;
    } else {
      $("#OCCUPATION").addClass("ng-untouched ng-valid");
      $("#OCCUPATION").removeClass("ng-touched ng-invalid validate-error");
    }
    if (formData.RoleID === null || formData.RoleID === "") {
      $("#RoleID").addClass("ng-touched ng-invalid validate-error");
      $("#RoleID").removeClass("ng-untouched ng-valid");
      message += "Please enter Role.<br/>";
      isValid = false;
    } else {
      $("#RoleID").addClass("ng-untouched ng-valid");
      $("#RoleID").removeClass("ng-touched ng-invalid validate-error");
    }
    if (formData.ADDRESS === null || formData.ADDRESS === "") {
      $("#ADDRESS").addClass("ng-touched ng-invalid validate-error");
      $("#ADDRESS").removeClass("ng-untouched ng-valid");
      message += "Please enter Address.<br/>";
      isValid = false;
    } else {
      $("#ADDRESS").addClass("ng-untouched ng-valid");
      $("#ADDRESS").removeClass("ng-touched ng-invalid validate-error");
    }
    
    if (formData.POSTAL_CODE === null || formData.POSTAL_CODE === "") {
      $("#POSTAL_CODE").addClass("ng-touched ng-invalid validate-error");
      $("#POSTAL_CODE").removeClass("ng-untouched ng-valid");
      message += "Please enter Postal Code.<br/>";
      isValid = false;
    } else {
      $("#POSTAL_CODE").addClass("ng-untouched ng-valid");
      $("#POSTAL_CODE").removeClass("ng-touched ng-invalid validate-error");
    }

    if (formData.CITY === null || formData.CITY === "") {
      $("#CITY").addClass("ng-touched ng-invalid validate-error");
      $("#CITY").removeClass("ng-untouched ng-valid");
      message += "Please enter City.<br/>";
      isValid = false;
    } else {
      $("#CITY").addClass("ng-untouched ng-valid");
      $("#CITY").removeClass("ng-touched ng-invalid validate-error");
    }

    if (formData.PROVINCE === null || formData.PROVINCE === "") {
      $("#PROVINCE").addClass("ng-touched ng-invalid validate-error");
      $("#PROVINCE").removeClass("ng-untouched ng-valid");
      message += "Please enter Province.<br/>";
      isValid = false;
    } else {
      $("#PROVINCE").addClass("ng-untouched ng-valid");
      $("#PROVINCE").removeClass("ng-touched ng-invalid validate-error");
    }

    if (formData.COUNTRY === null || formData.COUNTRY === "") {
      $("#COUNTRY").addClass("ng-touched ng-invalid validate-error");
      $("#COUNTRY").removeClass("ng-untouched ng-valid");
      message += "Please enter Country.<br/>";
      isValid = false;
    } else {
      $("#COUNTRY").addClass("ng-untouched ng-valid");
      $("#COUNTRY").removeClass("ng-touched ng-invalid validate-error");
    }

    if (formData.EMAIL === null || formData.EMAIL === "" || formData.EMAIL === undefined) {
      $("#EMAIL").addClass("ng-touched ng-invalid validate-error");
      $("#EMAIL").removeClass("ng-untouched ng-valid");
      message += "Please enter E-Mail.<br/>";
      isValid = false;
    } else {
      const mailformat = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
      if (formData.EMAIL.match(mailformat)) {
        $("#EMAIL").addClass("ng-untouched ng-valid");
        $("#EMAIL").removeClass("ng-touched ng-invalid validate-error");
      }
      else {
        $("#EMAIL").addClass("ng-touched ng-invalid validate-error");
        $("#EMAIL").removeClass("ng-untouched ng-valid");
        message += "Please enter Valid E-Mail.<br/>";
        isValid = false;
      }
    }
    if (formData.PHONE === null || formData.PHONE === "") {
      $("#PHONE").addClass("ng-touched ng-invalid validate-error");
      $("#PHONE").removeClass("ng-untouched ng-valid");
      message += "Please enter Phone Number.<br/>";
      isValid = false;
    } else {
      const phoneformat = /^[1-9]\d*$/;
      formData.PHONE = formData.PHONE + "";
      if (formData.PHONE.match(phoneformat)) {
        $("#PHONE").addClass("ng-untouched ng-valid");
        $("#PHONE").removeClass("ng-touched ng-invalid validate-error");
      }
      else {
        $("#PHONE").addClass("ng-touched ng-invalid validate-error");
        $("#PHONE").removeClass("ng-untouched ng-valid");
        message += "Please enter Valid Phone Number.<br/>";
        isValid = false;
      }
    }

    if (formData.PHONE_EXT === null || formData.PHONE_EXT === "") {
      $("#PHONE_EXT").addClass("ng-touched ng-invalid validate-error");
      $("#PHONE_NO_EXT").removeClass("ng-untouched ng-valid");
      message += "Please enter Phone Ext.<br/>";
      isValid = false;
    } else {
      $("#PHONE_EXT").addClass("ng-untouched ng-valid");
      $("#PHONE_EXT").removeClass("ng-touched ng-invalid validate-error");
    }



    if (formData.OTHER_PHONE !== null && formData.OTHER_PHONE !== "") {
      const phoneformat = /^[1-9]\d*$/;
      formData.OTHER_PHONE = formData.OTHER_PHONE + "";
      if (formData.OTHER_PHONE.match(phoneformat)) {
        $("#OTHER_PHONE").addClass("ng-untouched ng-valid");
        $("#OTHER_PHONE").removeClass("ng-touched ng-invalid validate-error");
      }
      else {
        $("#OTHER_PHONE").addClass("ng-untouched ng-valid");
        $("#OTHER_PHONE").removeClass("ng-touched ng-invalid validate-error");
        message += "Please enter valid alternate Phone Number.<br/>";
        isValid = false;
      }
    }

    if (formData.OTHER_PHONE_EXT !== null && formData.OTHER_PHONE_EXT !== "") {
      const phoneformat = /^[1-9]\d*$/;
      formData.OTHER_PHONE_EXT = formData.OTHER_PHONE_EXT + "";
      if (formData.OTHER_PHONE_EXT.match(phoneformat)) {
        $("#OTHER_PHONE_EXT").addClass("ng-untouched ng-valid");
        $("#OTHER_PHONE_EXT").removeClass("ng-touched ng-invalid validate-error");
      }
      else {
        $("#OTHER_PHONE_EXT").addClass("ng-untouched ng-valid");
        $("#OTHER_PHONE_EXT").removeClass("ng-touched ng-invalid validate-error");
        message += "Please enter valid alternate Phone Ext.<br/>";
        isValid = false;
      }
    } 
    if (!isValid) {
      this.commonService.ValidationBanner(message);
     // this.modalService.show(MessageBoxComponent, { data: { heading: 'Validations', content: { heading: '', description: message } } });
      this.IsClicked = false
    }
    return isValid;
  }
 


 
  onUploadOutput(output: any | any): void {
    debugger;
    if (output.type === 'allAddedToQueue') {
    } else if (output.type === 'addedToQueue') {
      debugger;
      if (this.files == undefined || this.files == null) {
        this.files = [];
      }
      this.files.push(output.file); // add file to array when added
    } else if (output.type === 'uploading') {
      // update current data in files array for uploading file
      const index = this.files.findIndex(file => file.id === output.file.id);
      this.files[index] = output.file;
    } else if (output.type === 'removed') {
      // remove file from array when removed
      this.files = this.files.filter((file: any) => file !== output.file);
    } else if (output.type === 'dragOver') {
      this.dragOver = true;
    } else if (output.type === 'dragOut') {
    } else if (output.type === 'drop') {
      this.dragOver = false;
    }
  }
}
